import React, { useState } from "react";
import styles from "./ProjectCard.module.css";
import removeMiddleSpaces from "../../utils";
import { ArrowUpRight, Layers } from "../common/Icons";
import { Github } from "../common/BrandIcons";
import LiquidGlass from "../common/LiquidGlass";
import Reveal from "../common/Reveal";

const ProjectCard = ({ project, index = 0 }) => {
  const { title, description, skills, demo, source, video, image } = project;
  const [imgError, setImgError] = useState(false);

  // Projects usually fall back to a screenshot named after the title. A project
  // may also name its own asset, which is how a hand-authored SVG poster works.
  const poster = `./assets/projects/${image || `${removeMiddleSpaces(title)}.png`}`;

  const host = demo ? demo.replace(/^https?:\/\//, "").replace(/\/+$/, "") : "";

  return (
    <Reveal as={LiquidGlass} blur="none" className={styles.card} delay={(index % 3) * 80}>
      <div className={styles.media}>
        {video ? (
          <video
            className={styles.mediaVideo}
            autoPlay
            loop
            muted
            playsInline
            poster={poster}
          >
            <source src={video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : !imgError ? (
          <img
            src={poster}
            alt={`${title} screenshot`}
            loading="lazy"
            decoding="async"
            onError={() => setImgError(true)}
          />
        ) : (
          <div className={styles.fallback}>
            <Layers size={24} />
            <span>{title}</span>
          </div>
        )}
      </div>

      <div className={styles.body}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.text}>{description}</p>

        <div className={styles.tags}>
          {skills.slice(0, 4).map((skill, index) => (
            <span key={`${skill}-${index}`} className={styles.tag}>
              {skill}
            </span>
          ))}
          {skills.length > 4 && <span className={styles.more}>+{skills.length - 4}</span>}
        </div>
      </div>

      <div className={styles.footer}>
        {demo && (
          <a
            className={styles.demoLink}
            href={demo}
            target="_blank"
            rel="noreferrer"
            aria-label={`Open the live site for ${title}`}
          >
            <span>{host.startsWith("www.npmjs.com") ? "npm page" : "Live site"}</span>
            <ArrowUpRight size={14} />
          </a>
        )}
        {source && (
          <a
            className={styles.codeLink}
            href={source}
            target="_blank"
            rel="noreferrer"
            aria-label={`Read the source code for ${title}`}
          >
            <Github size={14} />
            <span>Code</span>
          </a>
        )}
        {host && <span className={styles.host}>{host}</span>}
      </div>
    </Reveal>
  );
};

export default ProjectCard;